module.exports = __webpack_public_path__ + "static/thoughts-and-flowers-of-a-warrior-in-a-sandbox_2007-ffeb3efb307ee2f821ebeec825d3af8d.jpg";